// 원서 워크북에서 AI 가 채점 · 첨삭할 문항(2026-10-17). 지인에듀가 모범 답만 준 문항이다:
// 짧게 쓰기(short, 채점 안 하는 input) · 서술형(written) · 표(table).
// 서버(api/assignment/book_grading_views.py)는 모범 답(answer_parts)이 그 섹션 책 자료에 있는 글인지 보고 매긴다.

const textOf = (value) => String(value || "").trim();

// 활동 하나 → AI 에게 보낼 문항 목록. index 는 화면 문항 순번이고 결과를 그 자리에 꽂는다.
export const aiGradeItemList = (activity, response) => {
  const value = response || {};
  if (activity.kind === "input") {
    return activity.items
      .map((item, index) => ({ item, index }))
      .filter(({ item }) => !item.gradeable && item.answer)
      .map(({ item, index }) => ({
        id: String(index),
        index,
        prompt: item.prompt || "",
        quote: item.quote || "",
        explanation: item.explanation || "",
        answer_parts: [item.answer],
        text: textOf(value[index]),
      }));
  }
  if (activity.kind === "written") {
    return activity.items
      .map((item, index) => ({ item, index }))
      .filter(({ item }) => item.answer)
      .map(({ item, index }) => ({
        id: String(index),
        index,
        prompt: item.prompt || "",
        quote: item.quote || "",
        explanation: [item.explanation, ...(item.rubricList || []).map((rubric) => `${rubric.criterion}: ${rubric.description}`)]
          .filter(Boolean)
          .join("\n"),
        answer_parts: [item.answer],
        text: textOf(value[index]),
      }));
  }
  if (activity.kind === "table") {
    // 표는 칸마다 매기면 문항이 너무 잘게 쪼개진다. 표 하나를 '줄 이름: 칸, 칸' 글 한 덩어리로 보낸다.
    return activity.items.map((item, itemIndex) => {
      const filled = value[itemIndex] || {};
      const lineOf = (row, cellList) => `${row.label}: ${cellList.filter(Boolean).join(" / ")}`;
      return {
        id: String(itemIndex),
        index: itemIndex,
        prompt: [item.prompt, `(${item.headerList.join(" / ")})`].filter(Boolean).join(" "),
        quote: "",
        explanation: "표의 줄마다 칸을 채운 것이다. 모범 답과 뜻이 같으면 맞다.",
        answer_parts: item.rowList.flatMap((row) => row.answerList.filter(Boolean)),
        text: item.rowList
          .map((row, rowIndex) =>
            lineOf(row, item.headerList.map((_, column) => textOf(filled[`${rowIndex}:${column}`])))
          )
          .filter((line) => !line.endsWith(": "))
          .join("\n"),
      };
    });
  }
  return [];
};

// AI 판정 → 화면 결과(true 맞음 · false 틀림 · "half" 부분). 점수는 report 줄의 score 가 따로 든다.
export const verdictToResult = (verdict) => {
  if (verdict === "ok") return true;
  if (verdict === "half") return "half";
  return false;
};
